import { ResearchTransactionModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../shared';

export const defaultResearchTransactionModelDto: ResearchTransactionModelDto = {
    id: 0,
    updatedDate: '',
    date: '',
    accountNumber: '',
    checkImageNumber: '',
    description: '',
    amount: 0,
    checkNumber: '',
    accountName: '',
    accountType: '',
    transactionId: '',
    transactionType: '',
    isDebit: false,
    checkNumberSortValue: '',
    transactionCodeDescription: '',
};

export class ResearchedTransaction extends DomainEntity<ResearchTransactionModelDto> {
    constructor(public source: ResearchTransactionModelDto) {
        super(source);
    }

    public createDefault(): this {
        return new ResearchedTransaction(defaultResearchTransactionModelDto) as this;
    }

    public get id() {
        return this.source.id;
    }

    public get date() {
        return this.source.date;
    }

    public get accountNumber() {
        return this.source.accountNumber;
    }

    public get checkImageNumber() {
        return this.source.checkImageNumber;
    }

    public get description() {
        return this.source.description;
    }

    public get amount() {
        return this.source.amount;
    }

    public get checkNumber() {
        return this.source.checkNumber;
    }

    public get accountName() {
        return this.source.accountName;
    }

    public get accountType() {
        return this.source.accountType;
    }

    public get transactionId() {
        return this.source.transactionId;
    }

    public get transactionType() {
        return this.source.transactionType;
    }

    public get isDebit() {
        return this.source.isDebit;
    }

    public get transactionCodeDescription() {
        return this.source.transactionCodeDescription;
    }
}
